import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const marginListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'rateSourceId',
    label: 'Rate Type',
  },
  {
    name: 'currencyFromId',
    label: 'From',
  },
  {
    name: 'currencyToId',
    label: 'To',
  },
  {
    name: 'isCustom',
    label: 'Fees settings',
  },
];

export const marginListColumnsLabels = {
  rateSourceId: 'Rate source',
};

export const allMarginListColumnsLabels = {
  rateSourceId: 'Rate source',
  currencyToId: 'Currency to',
};

export const marginListSchema = {
  rateSourceId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const allMarginListSchema = {
  rateSourceId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const marginListFiltersSchema = [
  {
    name: 'rateSourceId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
];

export const allMarginListFiltersSchema = [
  {
    name: 'rateSourceId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
  {
    name: 'currencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
];
